import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../axios.js';
import moment from 'moment/moment';

import './Resources/dashboard.css';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';
import Create_bank from './create_bank';



import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";

import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

//EXCEL DOWNLOAD IMPORT
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Create_stock from './create_stock.js';

function Team_broker_debtors(){

 //Report Print Function
 const componentRef = useref();
 const handlePrint = useReactToPrint({
   content: () => componentRef.current,
 });

 //Report Print Function 1
 const componentRef1 = useref();
 const handlePrint1 = useReactToPrint({
   content: () => componentRef1.current,
 });


 /*
 // Function to download the data as an Excel file
 const downloadExcel = () => {
  // Convert JSON data to Excel worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);
  
  // Create a new workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
  // Convert the workbook to a binary array
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  
  // Create a Blob from the binary data and trigger a download
  const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(excel_data, "bank_data.xlsx");
};
*/



 // Function to download the bank_summary as an Excel file
 const downloadExcel1 = () => {
  // Convert JSON data to Excel worksheet
  const worksheet1 = XLSX.utils.json_to_sheet(bank_summary);
  
  // Create a new workbook and add the worksheet
  const workbook1 = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook1, worksheet1, "Sheet1");
  
  // Convert the workbook to a binary array
  const excelBuffer1 = XLSX.write(workbook1, { bookType: "xlsx", type: "array" });
  
  // Create a Blob from the binary data and trigger a download
  const excel_data1 = new Blob([excelBuffer1], { type: "application/octet-stream" });
  saveAs(excel_data1, "bank_summary.xlsx");
};

  
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");
 const bcode=sessionStorage.getItem("BCode00");


 
 
{/* TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
const[cd_col12_val,setcd_col12_val] = useState(0);//column12
{/*const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14 */}

{/* TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES END */}


 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 /*if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
  else{ */



    
 //SETTING DEFAULT STATE VARIABLES FOR CHART */
 
 //LINECHART VARIABLES
 const[lc_summary,setlc_summary] = useState([],);
 const[lc_inflow,setlc_inflow] = useState([],);
 const[lc_outflow,setlc_outflow] = useState([],);
 const[lc_netcashflow,setlc_netcashflow] = useState([],);

 //Line Chart
 const[lc_date,setlc_date] = useState();
 const[lc_default,setlc_default] = useState(0);
 const[lc_start_date,setlc_start_date] = useState(0);const updatelc_start_date = (event) => { setlc_start_date(event.target.value); }; 
 const[lc_end_date,setlc_end_date] = useState(0);const updatelc_end_date = (event) => { setlc_end_date(event.target.value); }; 
 const[lc_date_error,setlc_date_error] = useState();

 //Bar Chart
 const[bc_default,setbc_default] = useState(0);
 const[bc_start_date,setbc_start_date] = useState(0);const updatebc_start_date = (event) => { setbc_start_date(event.target.value); }; 
 const[bc_end_date,setbc_end_date] = useState(0);const updatebc_end_date = (event) => { setbc_end_date(event.target.value); }; 
 const[bc_date_error,setbc_date_error] = useState();
 const[bc_entry,setbc_entry] = useState();
 const[bc_drawings,setbc_drawings] = useState();
 const[bc_incomes,setbc_incomes] = useState();
 const[bc_expenses,setbc_expenses] = useState();
 const[bc_sales,setbc_sales] = useState();
 const[bc_purchases,setbc_purchases] = useState();
 /*const[bc_salesreturn,setbc_salesreturn] = useState();
 const[bc_purchasereturns,setbc_purchasereturns] = useState();
 const[bc_creditorpayment,setbc_creditorpayment] = useState();
 const[bc_debtorpayment,setbc_debtorpayment] = useState();
 const[bc_osexpenses,setbc_osexpenses] = useState();
 const[bc_osincomes,setbc_osincomes] = useState();
*/
      
//Variables
const[banks,setbanks] = useState([]);//SetData Variable
const[data,setData] = useState([]);//SetData Variable
const[bank_summary,setbank_summary] = useState([]);//Setbank_summary Variable

//Error Variable
const[errorvar,seterrorvar] = useState();



//FILTER VARIABLES
const[filter_val,setfilter_val] = useState(0);
const[filter_start_date,setfilter_start_date] = useState('1970-01-01'); const updatefilter_start_date = (event) => { setfilter_start_date(event.target.value);}; const[filter_start_date_er,setfilter_start_date_er]=useState();
const[filter_end_date,setfilter_end_date] = useState('2100-12-12'); const updatefilter_end_date = (event) => { setfilter_end_date(event.target.value);}; const[filter_end_date_er,setfilter_end_date_er]=useState();
const[filter_trno,setfilter_trno] = useState(); const updatefilter_trno = (event) => { setfilter_trno(event.target.value);}; const[filter_trno_er,setfilter_trno_er]=useState();
const[filter_transaction,setfilter_transaction] = useState(); const updatefilter_transaction = (event) => { setfilter_transaction(event.target.value);}; const[filter_transaction_er,setfilter_transaction_er]=useState();
const[filter_amount_in_sign,setfilter_amount_in_sign] = useState(); const updatefilter_amount_in_sign = (event) => { setfilter_amount_in_sign(event.target.value);}; const[filter_amount_in_sign_er,setfilter_amount_in_sign_er]=useState();
const[filter_amount_in,setfilter_amount_in] = useState(); const updatefilter_amount_in = (event) => { setfilter_amount_in(event.target.value);}; const[filter_amount_in_er,setfilter_amount_in_er]=useState();
const[filter_amount_out_sign,setfilter_amount_out_sign] = useState(); const updatefilter_amount_out_sign = (event) => { setfilter_amount_out_sign(event.target.value);}; const[filter_amount_out_sign_er,setfilter_amount_out_sign_er]=useState();
const[filter_amount_out,setfilter_amount_out] = useState(); const updatefilter_amount_out = (event) => { setfilter_amount_out(event.target.value);}; const[filter_amount_out_er,setfilter_amount_out_er]=useState();
const[filter_bank,setfilter_bank] = useState(); const updatefilter_bank = (event) => { setfilter_bank(event.target.value);}; const[filter_bank_er,setfilter_bank_er]=useState();
//PART 2 FILTER VARIABLES
const[filter_val1,setfilter_val1] = useState(0);
const[filter_start_date1,setfilter_start_date1] = useState('1970-01-01'); const updatefilter_start_date1 = (event) => { setfilter_start_date1(event.target.value);}; const[filter_start_date1_er,setfilter_start_date1_er]=useState();
const[filter_end_date1,setfilter_end_date1] = useState('2100-12-12'); const updatefilter_end_date1 = (event) => { setfilter_end_date1(event.target.value);}; const[filter_end_date1_er,setfilter_end_date1_er]=useState();
const[filter_bank_name,setfilter_bank_name] = useState(); const updatefilter_bank_name = (event) => { setfilter_bank_name(event.target.value);}; const[filter_bank_name_er,setfilter_bank_name_er]=useState();
const[filter_vendor_name,setfilter_vendor_name] = useState(); const updatefilter_vendor_name = (event) => { setfilter_vendor_name(event.target.value);}; const[filter_vendor_name_er,setfilter_vendor_name_er]=useState();
const[filter_trade_name,setfilter_trade_name] = useState(); const updatefilter_trade_name = (event) => { setfilter_trade_name(event.target.value);}; const[filter_trade_name_er,setfilter_trade_name_er]=useState();
const[filter_booking_number,setfilter_booking_number] = useState(); const updatefilter_booking_number = (event) => { setfilter_booking_number(event.target.value);}; const[filter_booking_number_er,setfilter_booking_number_er]=useState();

const[filter_vendor_name1,setfilter_vendor_name1] = useState(); const updatefilter_vendor_name1 = (event) => { setfilter_vendor_name1(event.target.value);}; const[filter_vendor_name1_er,setfilter_vendor_name1_er]=useState();
const[filter_trade_name1,setfilter_trade_name1] = useState(); const updatefilter_trade_name1 = (event) => { setfilter_trade_name1(event.target.value);}; const[filter_trade_name1_er,setfilter_trade_name1_er]=useState();


//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);


useEffect(()=>{
   
  getData();
  
  },[])
 
    
  
//******************* GET BANKBOOK DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
      //Fetching Filter Variables
      const $filter_start_date = filter_start_date;const $filter_end_date = filter_end_date;const $filter_trno = filter_trno;const $filter_transaction = filter_transaction;
      const $filter_amount_in_sign = filter_amount_in_sign;const $filter_amount_in = filter_amount_in;const $filter_amount_out_sign = filter_amount_out_sign;const $filter_amount_out = filter_amount_out;
      const $filter_bank = filter_bank; const $filter_bank_name = filter_bank_name; const $filter_start_date1 = filter_start_date1;const $filter_end_date1 = filter_end_date1
      const $filter_vendor_name = filter_vendor_name; const $filter_trade_name = filter_trade_name; const $filter_booking_number = filter_booking_number;
      const $filter_vendor_name1 = filter_vendor_name1; const $filter_trade_name1 = filter_trade_name1;

 axios.post("brokervendorsummarydefaultload", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   //Line Chart
   lc_default:lc_default,
   lc_start_date:moment(lc_start_date).format('YYYY-MM-DD'),
   lc_end_date:moment(lc_end_date).format('YYYY-MM-DD'),
   //Bar Chart
   bc_default:bc_default,
   bc_start_date:moment(bc_start_date).format('YYYY-MM-DD'),
   bc_end_date:moment(bc_end_date).format('YYYY-MM-DD'),
  //Pie Chart
   pc_default:bc_default,
   pc_start_date:moment(bc_start_date).format('YYYY-MM-DD'),
   pc_end_date:moment(bc_end_date).format('YYYY-MM-DD'),
   //Filters
   Filter_val : filter_val,
   Filter_start_date : moment($filter_start_date).format('YYYY-MM-DD'),
   Filter_end_date : moment($filter_end_date).format('YYYY-MM-DD'),
   Filter_trno : $filter_trno,
   Filter_transaction : $filter_transaction,
   Filter_amount_in_sign : $filter_amount_in_sign,
   Filter_amount_in : $filter_amount_in,
   Filter_amount_out_sign : $filter_amount_out_sign,
   Filter_amount_out : $filter_amount_out,
   'Filter_bank' : $filter_bank,
   'Filter_val1' : filter_val1,
   'Filter_start_date1' : moment($filter_start_date1).format('YYYY-MM-DD'),
   'Filter_end_date1' : moment($filter_end_date1).format('YYYY-MM-DD'),
   'Filter_bank_name' : $filter_bank_name,
   'Filter_vendor_name' : $filter_vendor_name,
   'Filter_trade_name' : $filter_trade_name,
   'Filter_booking_number' : $filter_booking_number,
   'Filter_type' : $filter_transaction,
   'Filter_cdname' : $filter_trade_name1,
   'Filter_cdname1' : $filter_vendor_name1,
   //Code Edits for pagination
  'page' : pageNumber,
  Bcode: bcode,

 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setbanks(response.data.banks);
   setData(response.data.data.data);
   setbank_summary(response.data.summary.data);
   //console.log(response.data.bank_summary.data);

   const lc_summary = response.data.lc_summary;
   // Extract data for line chart
   setlc_date(lc_summary.map((entry) => entry.Date));
   setlc_inflow(lc_summary.map((entry) => entry.Inflow));
   setlc_outflow(lc_summary.map((entry) => entry.Outflow)); 
   //extract data for bar chart
   setbc_entry(response.data.bc_sugars);
   setbc_drawings(response.data.sugars30);
   setbc_incomes(response.data.sugarm);
   setbc_expenses(response.data.sugarm30);
   setbc_sales(response.data.bc_molas);
   //setbc_purchases(response.data.bc_purchases);
  /* setbc_salesreturn(response.data.bc_salesreturn);
   setbc_purchasereturns(response.data.bc_purchasereturns);
   setbc_osincomes(response.data.bc_osincomes);
   setbc_osexpenses(response.data.bc_osexpenses);
   setbc_creditorpayment(response.data.bc_creditorpayment);
   setbc_debtorpayment(response.data.bc_debtorpayment);*/
  
  }
   //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){
    setfilter_start_date_er(response.data.validatorerror.Filter_start_date);
    setfilter_end_date_er(response.data.validatorerror.Filter_end_date);
    setfilter_trno_er(response.data.validatorerror.Filter_trno);
    setfilter_transaction_er(response.data.validatorerror.Filter_transaction);
    setfilter_amount_in_sign_er(response.data.validatorerror.Filter_amount_in_sign);
    setfilter_amount_in_er(response.data.validatorerror.Filter_amount_in);
    setfilter_amount_out_sign_er(response.data.validatorerror.Filter_amount_out_sign);
    setfilter_amount_out_er(response.data.validatorerror.Filter_amount_out);
    setfilter_bank_er(response.data.validatorerror.Filter_bank);
    setfilter_bank_name_er(response.data.validatorerror.Filter_bank_name);
    setfilter_start_date1_er(response.data.validatorerror.Filter_start_date1);
    setfilter_end_date1_er(response.data.validatorerror.Filter_end_date1);
  }

  //Data Violation
  if(response.data.error==102){ 
  
    
    setfilter_start_date_er(response.data.filter_start_date_er);
    setfilter_end_date_er(response.data.filter_end_date_er);
    setfilter_trno_er(response.data.filter_trno_er);
    setfilter_transaction_er(response.data.filter_transaction_er);
    setfilter_amount_in_sign_er(response.data.filter_amount_in_sign_er);
    setfilter_amount_in_er(response.data.filter_amount_in_er);
    setfilter_amount_out_er(response.data.filter_amount_out_er);
    setfilter_amount_out_sign_er(response.data.filter_amount_out_sign_er);
    setfilter_bank_er(response.data.filter_bank_er);
    setfilter_bank_name_er(response.data.filter_bank_name_er);
    setfilter_start_date1_er(response.data.filter_start_date1_er);
    setfilter_end_date1_er(response.data.filter_end_date1_er);
    

  }
  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* GET BANKBOOK DATA FUNCTION END  ********************//

 

 /* LINE CHART START */
 const data1 = {
  labels: lc_date,
  datasets: [
    {
      label: "Stock Outflow",
      backgroundColor: ["rgba(190, 255, 99, 1)" ],
      borderColor: "rgba(190, 255, 99, 1)",
      data: lc_outflow,
    },
    {
      label: "Stock Inflow",
      backgroundColor: ["rgba(3, 144, 59, 1)"],
      borderColor: "rgba(3, 144, 59, 1)",
      data: lc_inflow,
    },
  ],
};
/* LINE CHART END */ 

 /* BAR CHART VARIABLES START */
  const labels2 = ["Sugar S", "Sugar S30", "Sugar M", "Sugar M30", "Molasis"/*, "Expenses"*/];

  const data2 = {
    labels: labels2,
    datasets: [
      {
        label: [],
        backgroundColor: ["#25d494", "#d42641", "#26cdd4", "#d45e26", "#d0d943", "#d98843"/*, "#ffe585"*/ ],
        borderColor: "rgba(99, 255, 112, 1)",
        data: [bc_entry, bc_drawings, bc_sales, bc_purchases, bc_incomes, bc_expenses],
      },
     
    ],
  };
  /* BAR CHART VARIABLES END */


 
//******************* GET GODOWN DATA BY ID FUNCTION START  ********************//



//egodown_name
const[egodown_name,setegodown_name]=useState();const updateegodown_name = (event) => { setegodown_name(event.target.value);}; const[egodown_name_er,setegodown_name_er]=useState();
//egodown_code
const[egodown_code,setegodown_code]=useState();const updateegodown_code = (event) => { setegodown_code(event.target.value);}; const[egodown_code_er,setegodown_code_er]=useState();
//egodown_remarks
const[egodown_remarks,setegodown_remarks]=useState();const updateegodown_remarks = (event) => { setegodown_remarks(event.target.value);}; const[egodown_remarks_er,setegodown_remarks_er]=useState();
//egodown_status
const[egodown_status,setegodown_status]=useState();const updateegodown_status = (event) => { setegodown_status(event.target.value);}; const[egodown_status_er,setegodown_status_er]=useState();


//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();




//Edit Function
function getbankdatabyId(){
 

  const bankId=sessionStorage.getItem("BankId00");

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&(bankId>0)){
 
 
 axios.post("godowndetails", {
   Log_id:logid,
   Token:token,
   Bank_id:bankId
 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");
     sessionStorage.removeItem("BankId00");


     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){

   //Setting Data
   setegodown_name(response.data.godown_name);
   setegodown_code(response.data.godown_code);
   setegodown_status(response.data.godown_status);
   setegodown_remarks(response.data.godown_remarks);
  
  }
  //Cannot Fetch Data
  else{


      document.getElementById("edit-form1").style.display="none";

     //Setting Variables to empty 
     setegodown_name_er(" ");setegodown_code_er(" ");setegodown_remarks_er();setegodown_status_er();seterror_msg(" ");
  

      document.getElementById("edit-error-card1").style.display="block"; 
      sessionStorage.removeItem("BankId00");
  }
 
 
 });
 
 }
 //User not Logedin
 else{

     //Checking if user loggedin
     if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))){
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
     }
 
  }
 
 }
  
 //******************* GET GODOWN DATA BY ID FUNCTION END  ********************//

   

//******************* GET STOCK DATA IN EXCEL FUNCTION START  ********************//
function downloadExcel(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
    //Fetching Filter Variables
    const $filter_start_date = filter_start_date;const $filter_end_date = filter_end_date;const $filter_trno = filter_trno;const $filter_transaction = filter_transaction;
    const $filter_amount_in_sign = filter_amount_in_sign;const $filter_amount_in = filter_amount_in;const $filter_amount_out_sign = filter_amount_out_sign;const $filter_amount_out = filter_amount_out;

 axios.post("brokervendorsummarylistinexcel", {
     Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   //Line Chart
   lc_default:lc_default,
   lc_start_date:moment(lc_start_date).format('YYYY-MM-DD'),
   lc_end_date:moment(lc_end_date).format('YYYY-MM-DD'),
   //Bar Chart
   bc_default:bc_default,
   bc_start_date:moment(bc_start_date).format('YYYY-MM-DD'),
   bc_end_date:moment(bc_end_date).format('YYYY-MM-DD'),
  //Pie Chart
   pc_default:bc_default,
   pc_start_date:moment(bc_start_date).format('YYYY-MM-DD'),
   pc_end_date:moment(bc_end_date).format('YYYY-MM-DD'),
   //Filters
   Filter_val : filter_val,
   Filter_start_date : moment($filter_start_date).format('YYYY-MM-DD'),
   Filter_end_date : moment($filter_end_date).format('YYYY-MM-DD'),
   Filter_trno : $filter_trno,
   Filter_transaction : $filter_transaction,
   Filter_amount_in_sign : $filter_amount_in_sign,
   Filter_amount_in : $filter_amount_in,
   Filter_amount_out_sign : $filter_amount_out_sign,
   Filter_amount_out : $filter_amount_out,
   Filter_type : $filter_transaction,
  // 'Filter_bank' : $filter_bank,
   'Filter_val1' : filter_val1,
   
   //Code Edits for pagination
  'page' : pageNumber,
  Bcode: bcode,
  
//Code Edits for pagination
'page' : pageNumber




 })
 .then((response) => {


      //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");

     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){

//Setting Data
   const exceldata =response.data.data;
   
   // Convert JSON data to Excel worksheet
   const worksheet = XLSX.utils.json_to_sheet(exceldata);
   
   // Create a new workbook and add the worksheet
   const workbook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
   
   // Convert the workbook to a binary array
   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
   
   // Create a Blob from the binary data and trigger a download
   const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
   saveAs(excel_data, "data.xlsx");
  }
  //Cannot Fetch Data
  else{
    seterrorvar("Cannot Download Excel File !");
  } 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* GET STOCK DATA IN EXCEL FUNCTION END  ********************//

return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>React App</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div class="container-scroller">

      <Sidebar />
    <div class="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div class="main-panel">

           {/* ADD STOCK SUCCESS CARD START */}
           <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card1">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Vendor Payment Added Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <a href="/teampane--dashboard-vendor-payments"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD STOCK SUCCESS CARD END */}
                   {/* ADD BANK EDIT SUCCESS CARD START */}
        {/*<div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-success-card1">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Bank Updated Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("edit-success-card1").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>*/}
              {/* ADD BANK EDIT SUCCESS CARD END */}
               {/* ADD BANK EDIT ERROR CARD START */}
       {/*} <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-error-card1">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-danger">Cannot Fetch Data !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("edit-error-card1").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div> */}
              {/* ADD BANK EDIT ERROR CARD END */}





             {/* SUCCESS CARD START */}
          <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Vendor Payment Added Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <a href="/teampane--dashboard-vendor-payments"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
          

          <div class="content-wrapper pb-0">
          
                   
         

            <div class="page-header flex-wrap">
            <div class="header-left"></div>
              <div class="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pe-3">Vendor Payments</p>
                  </a>
                  <a class="ps-3 me-4" href="#">
                  {/*}  <p class="m-0">ADE-00234</p> */}
                  </a>
                </div>
            
              {/*}  <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text" onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i class="mdi mdi-plus-circle"></i> New Vendor Payment</button> */}

              </div>
            </div>

            {/*} chart row starts here */}
            <div class="row">
              {/* LINECHART START
              <div className="col-sm-6 stretch-card grid-margin">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between">
                    <div className="card-title">Vendor Payment Flow
                      </div>
                      <div className="d-flex text-muted font-20">
                        <i className="mdi mdi-arrow-down-drop-circle text-primary" onClick={()=>{ document.getElementById("lc-date-search-box").style.display="block"; }}></i>
                        <i className="mdi mdi-close-box text-danger"  onClick={()=>{ document.getElementById("lc-date-search-box").style.display="none"; }}></i>
                      
                      </div>
                    </div>
                    {/* LINE CHART DATE FILTER START
                    <div id="lc-date-search-box" style={{display:"none"}}>
                    <hr />
                    <p style={{marginTop:"2rem"}}>Make sure start date and end date are not more than 10 days apart for best results</p>
                    <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label"> Start Date</label>
                            <div className="col-sm-9">
                              <input type="date" className="form-control-sm"  id="lc_start_date" value={lc_start_date} onChange={updatelc_start_date} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">End Date</label>
                            <div className="col-sm-9">
                              <input type="date" className="form-control-sm" id="lc_end_date" value={lc_end_date} onChange={updatelc_end_date} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <button class="btn btn-primary mb-4" onClick={()=>{ setlc_default(1); getData(); }}>Update</button>
                      <hr/>
                      </div>
                      {/* LINE CHART DATE FILTER END 
              
                    <div className="line-chart-wrapper">
                  {/* bpm INFLOW OUTFLOW LINE CHART START 
                  <Line data={data1} /> 
                  {/* bpm INFLOW OUTFLOW LINE CHART END 
                    </div>
                  </div>
                </div>
              </div>
               {/* LINECHART END */}
              {/* BARCHART START 
              <div className="col-sm-6 stretch-card grid-margin">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between">
                    <div className="card-title">Payment Summary
                      </div>
                      <div className="d-flex text-muted font-20">
                      {/*}  <i className="mdi mdi-printer mouse-pointer"></i>
                        <i className="mdi mdi-help-circle-outline ms-2 mouse-pointer"></i> 
                        <i className="mdi mdi-arrow-down-drop-circle text-primary" onClick={()=>{ document.getElementById("bc-date-search-box").style.display="block"; }}></i>
                        <i className="mdi mdi-close-box text-danger"  onClick={()=>{ document.getElementById("bc-date-search-box").style.display="none"; }}></i>
                      
                      </div>
                    </div>
                        {/*BAR CHART DATE FILTER START 
                        <div id="bc-date-search-box" style={{display:"none"}}>
                    <hr />
                    <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label"> Start Date</label>
                            <div className="col-sm-9">
                              <input type="date" className="form-control-sm"  id="bc_start_date" value={bc_start_date} onChange={updatebc_start_date} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">End Date</label>
                            <div className="col-sm-9">
                              <input type="date" className="form-control-sm" id="bc_end_date" value={bc_end_date} onChange={updatebc_end_date} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <button class="btn btn-primary mb-4" onClick={()=>{ setbc_default(1); getData(); }}>Update</button>
                      <hr/>
                      </div>
                      {/* BAR CHART DATE FILTER END 
                    <div className="bar-chart-wrapper">
                      {/* SUMMARY BARCHART START 
                      <Bar data={data2} />
                      {/* SUMMARY BARCHART END 
                    </div>
                  </div>
                </div>
              </div>
              {/* BARCHART END */}
            </div>


             {/* BANKBOOK EDIT FORM START 
             <div class="row">
              <div class="col-12 grid-margin create-form" id="edit-form" style={{display:"none"}}>
              <div class="card">
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ 
                         //close edit form button
                         document.getElementById("edit-form").style.display="none";
                        //Setting Variables to empty
                        //Setting Variables to empty 
                        setedate_er(" ");setetype_er(" ");seteparticular_er(" ");seteamount_er(" ");seterror_msg(" ");   
                        setedate(" ");setetype(" ");seteparticular(" ");seteamount(" ");                     
                        sessionStorage.removeItem("Bankid00");
                        sessionStorage.removeItem("Trno00"); }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Edit Bank Transaction</h4>
                    <div class="form-sample">
                      <p class="card-description">edit your bank transactions here</p>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Date<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" id="date" value={edate} onChange={updateedate} />
                              <code>{edate_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Transaction<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" style={{padding:"1rem"}} placeholder="Select Transaction" id="etype" value={etype} onChange={updateetype}>
                              <option value={etype}>{etype}</option>
                              <option value="">Select Transaction</option>
                              <option value="entry">Entry</option>
                              <option value="drawings">Drawings</option>
                              </select>
                              <code>{etype_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleTextarea1">Particular<code>*</code></label>
                        <textarea class="form-control" rows="2" id="eparticular" value={eparticular} onChange={updateeparticular} ></textarea>
                        <code>{eparticular_er}</code>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000.00" id="eamount" value={eamount} onChange={updateeamount} />
                              <code>{eamount_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Select Bank<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="Select Bank" style={{padding:"1rem"}} id="ebank_id" value={ebank_id} onChange={updateebank_id}>
                              <option value={ebank_id}>{ebanknm_id}</option>
                              {
                              banks.map((curElm1,ind)=>{

                              return(
                              <>
                              <option value={curElm1.Bank_id}>{curElm1.Bank_name}</option>
                              </>
                              )
                              }
                       
                                    )
                              }
                              </select>
                              <code>{ebank_id_er}</code>
                            </div>
                          </div>
                        </div>                      
                      </div>
                        
                      
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={editbankbook}>Submit</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>
              </div>
              </div>
              {/*BANKBOOK EDIT FORM END */}


              {/* BANKBOOK LIST SECTION START */}
             <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Vendor Payment Hisory</h4>
                    <p class="card-description">vendor payment history
                    </p>

    {/* FILTER SECTION START */}
    <hr/>
                            <div id="filter-top-card" class="row col-12" style={{textAlign:"left",display:"none"}}>
                            <div class="d-flex justify-content-between">
                            <div>
                            <h4 style={{padding:'1rem'}}>Filters</h4>
                           </div>
                           <div>
                    
                           <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("filter-top-card").style.display="none"; }}>
                           <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                           </button>
                           </div>
                           </div>
        
                        <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Start Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control" id="filter_start_date" value={filter_start_date} onChange={updatefilter_start_date}  />
                              <code>{filter_start_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">End Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control"  id="filter_end_date" value={filter_end_date} onChange={updatefilter_end_date}  />
                              <code>{filter_end_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Tr No.</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="12345"   id="filter_trno" value={filter_trno} onChange={updatefilter_trno}  />
                              <code>{filter_trno_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-8">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Debit</label>
                            <div class="col-sm-4">
                              <select class="form-control" style={{padding:"1rem"}} id="filter_amount_in_sign" value={filter_amount_in_sign} onChange={updatefilter_amount_in_sign}  >
                              <option className="dropdown-item" value=" ">All</option>
                              <option className="dropdown-item" value="equals">equals</option>
                              <option className="dropdown-item" value="more than" >more than</option>
                              <option className="dropdown-item" value="less than">less than</option>
                              <option className="dropdown-item" value="more than or equals" >more than or equals</option>
                              <option className="dropdown-item" value="less than or equals" >less than or equals</option>
                              </select>
                              <code>{filter_amount_in_sign_er}</code>
                            </div>
                            <div class="col-sm-4">
                              <input type="text" class="form-control" placeholder="5000.00" id="filter_amount_in" value={filter_amount_in} onChange={updatefilter_amount_in}   />
                              <code>{filter_amount_in_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Type</label>
                            <div class="col-sm-8">
                             <select class="form-control" style={{padding:"1rem"}} id="filter_transaction" value={filter_transaction} onChange={updatefilter_transaction} >
                             <option value=" ">Select Transaction</option>
                             <option value="sales">sales</option>
                             <option value="bpm">bpm</option>
                             <option value="bank">bank</option>
                             </select>                              
                             <code>{filter_transaction_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                    
                      <div class="row">
                      <div class="col-md-8">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Credit</label>
                            <div class="col-sm-4">
                              <select class="form-control" style={{padding:"1rem"}} id="filter_amount_out_sign" value={filter_amount_out_sign} onChange={updatefilter_amount_out_sign} >
                              <option className="dropdown-item" value=" ">All</option>
                              <option className="dropdown-item" value="equals">equals</option>
                              <option className="dropdown-item" value="more than" >more than</option>
                              <option className="dropdown-item" value="less than">less than</option>
                              <option className="dropdown-item" value="more than or equals" >more than or equals</option>
                              <option className="dropdown-item" value="less than or equals" >less than or equals</option>
                              </select>
                              <code>{filter_amount_out_sign_er}</code>
                            </div>
                            <div class="col-sm-4">
                              <input type="text" class="form-control" placeholder="5000.00" id="filter_amount_out" value={filter_amount_out} onChange={updatefilter_amount_out}   />
                              <code>{filter_amount_out_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Select Bank</label>
                            <div class="col-sm-9">
                              <select class="form-control" style={{padding:"1rem"}} placeholder="Select Bank" id="filter_bank_name" value={filter_bank_name} onChange={updatefilter_bank_name}>
                              <option value=" ">Select  Bank</option>
                              {
                              banks.map((curElm11,ind)=>{

                              return(
                              <>
                              <option value={curElm11.Bank_id}>{curElm11.Bank_name}</option>
                              </>
                              )
                              }
                       
                                    )
                              }
                              </select>
                              <code>{filter_bank_name_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                         <div class="row">
                           <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Vendor Name</label>
                            <div class="col-sm-8">
                             <input type="text" class="form-control" id="filter_vendor_name" placeholder="Vendor Name" value={filter_vendor_name} onChange={updatefilter_vendor_name} />
                                  
                             <code>{filter_vendor_name_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Trade Name</label>
                            <div class="col-sm-8">
                             <input type="text" class="form-control" id="filter_trade_name" placeholder="Trade Name" value={filter_trade_name} onChange={updatefilter_trade_name} />
                                  
                             <code>{filter_trade_name_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Booking Number</label>
                            <div class="col-sm-8">
                             <input type="text" class="form-control" id="filter_booking_number" placeholder="BK2026-01-050012" value={filter_booking_number} onChange={updatefilter_booking_number} />
                                  
                             <code>{filter_booking_number_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                      <button class="btn btn-primary" onClick={()=>{ setfilter_val(1); getData(); }}>Apply Filters</button>
                      <button class="btn btn-danger" style={{marginLeft:"1rem"}} onClick={()=>{ setfilter_val(0); getData(); }}>Remove Filters</button>
                      </div>

                            <hr/>                      
                            </div>
                            
                            {/* FILTER SECTION END */}

                    <div class="col-12" style={{marginBottom:"2rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                        {/* COLUMNS MANAGEMENT DROPDOWN START */}
                          <div class="dropdown">
                          <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>
                          {/*}  <button class="btn btn-primary dropdown-toggle" style={{marginLeft:"1rem"}} type="button" id="dropdownMenuIconButton1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="mdi mdi-table-large"></i>
                            </button>
                          */}

                          </div>
                          {/* COLUMNS MANAGEMENT DROPDOWN END */}

                          </div>
                          </div>

                    <div class="table-responsive" id="reports" ref={componentRef}>
                      <table class="table table-bordered table-hover">
                        <thead>
                          <tr >
                            <th  style={{fontWeight:"bold"}} hidden={cd_col1_val==1}>#</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1}>Tr No.</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col3_val==1}>Date</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1}>Booking Number</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col4_val==1}>Mode</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col4_val==1}>Vendor Name</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col4_val==1}>Trade Name</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col5_val==1}>Particular</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col6_val==1}>Debit</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col7_val==1}>Credit</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col9_val==1}>Updated By</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col10_val==1}>Updated At</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                       
                        <tr key={curElm.Id}>
                            <td>{ind+1}</td>
                            <td hidden={cd_col2_val==1}>{curElm.Tr_no}</td>
                            <td hidden={cd_col3_val==1}>{curElm.Date}</td>
                            <td hidden={cd_col3_val==1}>{curElm.Booking_number}</td>
                            <td hidden={cd_col4_val==1}>
                            <label className="badge badge-success" hidden={(curElm.Mode == "sales")||(curElm.Mode == "bank")}>bpm</label>
                            <label className="badge badge-primary" hidden={(curElm.Mode == "sales")||(curElm.Mode == "bpm")}>bank ({curElm.Bank_name})</label>
                            <label className="badge badge-warning" hidden={(curElm.Mode == "bank")||(curElm.Mode == "bpm")}>sales</label>
                            </td>
                           {/*} <td hidden={cd_col5_val==1}>{curElm.Mode}</td> */}
                            <td hidden={cd_col5_val==1}>{curElm.Vendor_name}</td>
                            <td hidden={cd_col5_val==1}>{curElm.Trade_name}</td>
                            <td hidden={cd_col6_val==1}>{curElm.Particular}</td>
                            <td hidden={cd_col7_val==1}>{curElm.Amount_in}</td>
                            <td hidden={cd_col8_val==1}>{curElm.Amount_out}</td>
                            <td hidden={cd_col9_val==1}>{curElm.Updated_by}</td>
                            <td hidden={cd_col10_val==1}>{curElm.Date_updated} ({curElm.Time_updated})</td>
                               
                          </tr>
                          </>
                         )
                         }
                       
                             )
                         }
                          
                      
                        </tbody>
                      </table>
                    </div>
                      {/* PAGINATION SECTION START */}
                      <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}

                    <button class="btn btn-light" onClick={handlePrint}><i class="mdi mdi-cloud-print text-dark"></i></button>
                    <button class="btn btn-light" onClick={downloadExcel}><i class="mdi mdi-file-excel text-dark"></i></button>


                  </div>
                </div>
              </div>
              {/* STOCK LIST SECTION END */}



              {/* GODOWN SUMMARY SECTION START */}
              <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Vendor Summary</h4>
                    <p class="card-description">vendor summary
                    </p>

                            {/* FILTER SECTION 1 START */}
                            <hr/>
                            <div id="filter-top-card1" class="row col-12" style={{textAlign:"left",display:"none"}}>
                            <div class="d-flex justify-content-between">
                            <div>
                            <h4 style={{padding:'1rem'}}>Filters</h4>
                           </div>
                           <div>
                    
                           <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("filter-top-card1").style.display="none"; }}>
                           <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                           </button>
                           </div>
                           </div>
        
                        <div class="row">
                       {/*} <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Start Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control" id="filter_start_date" value={filter_start_date1} onChange={updatefilter_start_date1}  />
                              <code>{filter_start_date1_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">End Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control"  id="filter_end_date" value={filter_end_date1} onChange={updatefilter_end_date1}  />
                              <code>{filter_end_date1_er}</code>
                            </div>
                          </div>
                        </div>*/}
                      
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Vendor Name</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control"  id="filter_cdname1" value={filter_vendor_name1} onChange={updatefilter_vendor_name1}  />
                              <code>{filter_vendor_name1_er}</code>
                            </div>
                          </div>
                        </div>
                          <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Trade Name</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control"  id="filter_name" value={filter_trade_name1} onChange={updatefilter_trade_name1}  />
                              <code>{filter_trade_name1_er}</code>
                            </div>
                          </div>
                        </div>

                     {/*}   <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Vendor Name</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control"  id="filter_end_date" value={filter_end_date1} onChange={updatefilter_end_date1}  />
                              <code>{filter_end_date1_er}</code>
                            </div>
                          </div>
                        </div>*/}

                      </div>
                      <div class="form-group">
                      <button class="btn btn-primary" onClick={()=>{ setfilter_val1(1); getData(); }}>Apply Filters</button>
                      <button class="btn btn-danger" style={{marginLeft:"1rem"}} onClick={()=>{ setfilter_val1(0); getData(); }}>Remove Filters</button>
                      </div>

                            <hr/>                      
                            </div>
                            
                            {/* FILTER SECTION 1 END */}

                    <div class="col-12" style={{marginBottom:"2rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card1").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>
                          </div>
                          </div>
                          </div>

                    <div class="table-responsive" id="reports" ref={componentRef1}>
                      <table class="table table-striped">
                        <thead>
                          <tr >
                           <th  style={{fontWeight:"bold"}}>#</th> 
                            <th  style={{fontWeight:"bold"}}>Vendor Name</th>
                            <th  style={{fontWeight:"bold"}}>Trade Name</th>
                            <th  style={{fontWeight:"bold"}}>Total Amount</th>
                            <th  style={{fontWeight:"bold"}}>Paid Amount</th>
                            <th  style={{fontWeight:"bold"}}>Balance</th>
                            <th  style={{fontWeight:"bold"}}>Status</th>
                           {/*} <th  style={{fontWeight:"bold"}}>Account Number</th> */}
                         
                           
                          </tr>
                        </thead>
                        <tbody>
                        {
                       bank_summary.map((curElm1,ind)=>{

                      return(
                       <>
  <tr key={ind}>
    <td>{ind + 1}</td>
    <td>{curElm1.Vendor_name}</td>
    <td>{curElm1.Trade_name}</td>
    <td>{curElm1.Total}</td>
    <td>{curElm1.Received}</td>
    <td>{curElm1.Due}</td>

    {/* STATUS COLUMN */}
    <td>
      {curElm1.Due === 0 ? (
        <span className="badge bg-success">Paid</span>
      ) : curElm1.Received > 0 && curElm1.Due > 0 ? (
        <span className="badge bg-warning text-dark">Partial</span>
      ) : curElm1.Received === 0 ? (
        <span className="badge bg-danger">Due</span>
      ) : curElm1.Received > curElm1.Total ? (
        <span className="badge bg-info">Advance</span>
      ) : null}
    </td>
    {/* ACTION */}
    <td>
    
    </td>
  </tr>
</>
                        )
                        }
                       
                            )
                        }
                          
                       
                        </tbody>
                      </table>
                    </div>
                      {/* PAGINATION SECTION START */}
                      <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}

                    <button class="btn btn-light" onClick={handlePrint1}><i class="mdi mdi-cloud-print text-dark"></i></button>
                    <button class="btn btn-light" onClick={downloadExcel1}><i class="mdi mdi-file-excel text-dark"></i></button>

                  </div>
                </div>
              </div>
            {/* BANKS SUMMARY SECTION END */}

            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
        {/*}  <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2023 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}

}
export default Team_broker_debtors;